export default __webpack_public_path__ + "static/media/Unmute Audio.0fbd4266.svg";